import { render, staticRenderFns } from "./kdxModalFrame.g.vue?vue&type=template&id=83555e24&scoped=true"
import script from "./kdxModalFrame.g.vue?vue&type=script&lang=js"
export * from "./kdxModalFrame.g.vue?vue&type=script&lang=js"
import style0 from "./kdxModalFrame.g.vue?vue&type=style&index=0&id=83555e24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83555e24",
  null
  
)

export default component.exports